export default __webpack_public_path__ + "static/realWorldImg1-bd405296fd81acf9e6de82e5dbe02c66.png";